import { tv, VariantProps } from 'tailwind-variants';

const headingVariants = tv({
  variants: {
    variant: {
      documentation: '',
      changelog: '',
    },
    level: {
      1: '',
      2: '',
      3: '',
    },
  },
  compoundVariants: [
    { variant: 'documentation', level: 1, class: 'text-4xl font-bold mb-6' },
    { variant: 'documentation', level: 2, class: 'text-3xl font-semibold mb-5' },
    { variant: 'documentation', level: 3, class: 'text-2xl font-semibold mb-4' },
    { variant: 'changelog', level: 1, class: 'text-2xl font-bold mb-4' },
    { variant: 'changelog', level: 2, class: 'text-xl font-semibold mb-4' },
    { variant: 'changelog', level: 3, class: 'text-lg font-semibold mb-4' },
  ],
  defaultVariants: {
    variant: 'documentation',
    level: 1,
  },
});

const summaryVariants = tv({
  base: 'cursor-pointer hover:opacity-80 transition-opacity',
  variants: {
    variant: {
      documentation: '',
      changelog: '',
    },
    level: {
      1: '',
      2: '',
      3: '',
    },
  },
  compoundVariants: [
    { variant: 'documentation', level: 1, class: 'text-4xl font-bold mb-6' },
    { variant: 'documentation', level: 2, class: 'text-3xl font-semibold mb-5' },
    { variant: 'documentation', level: 3, class: 'text-2xl font-semibold mb-4' },
    { variant: 'changelog', level: 1, class: 'text-2xl font-bold mb-4' },
    { variant: 'changelog', level: 2, class: 'text-xl font-semibold mb-4' },
    { variant: 'changelog', level: 3, class: 'text-lg font-semibold mb-4' },
  ],
  defaultVariants: {
    variant: 'documentation',
    level: 1,
  },
});

type HeadingVariant = VariantProps<typeof headingVariants>['variant'];

export { headingVariants, summaryVariants };
export type { HeadingVariant };
